// panel-wrapper.component.ts
import { Component, ViewChild, ViewContainerRef } from "@angular/core";
import { AuthService } from "src/app/auth/auth.service";
import { NgxMatPopoverComponent } from "src/app/shared/components/tooltip/ngx-mat-popover/ngx-mat-popover.component";
import { SortChangedEvent, SurveyQuestion } from "src/app/shared/models/survey";
import { LookupService } from "src/app/shared/services/lookup.service";
import { NotificationService } from "src/app/shared/services/notification.service";
import { SurveyService } from "src/app/shared/services/survey.service";
import { AnswerReviewFieldWrapper } from "./answer-review.field-wrapper";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "formly-wrapper-standard",
    templateUrl: "./standard-wrapper.component.html",
    styleUrls: ["./standard-wrapper.component.scss"],
    standalone: false
})
export class StandardWrapperComponent extends AnswerReviewFieldWrapper {
  @ViewChild("fieldComponent", { read: ViewContainerRef, static: true })
  // TS2612 fix.  Added declare.
  declare fieldComponent: ViewContainerRef;

  @ViewChild("popover", { static: true })
  readonly popover!: NgxMatPopoverComponent;

  constructor(
    authService: AuthService,
    surveyService: SurveyService,
    lookupService: LookupService,
    notificationService: NotificationService
  ) {
    super(authService, surveyService, lookupService, notificationService);
  }

  openPopover(): void {
    this.popover.open();
  }

  editQuestionClicked() {
    this.field.props.onEditQuestionClicked(
      this.field.props["question"]
    );
  }

  deleteQuestionClicked() {
    this.field.props.onDeleteQuestionClicked(
      this.field.props["question"]
    );
  }

  moveOrderUp() {
    const question = this.field.props["question"] as SurveyQuestion;
    const evt = {
      id: question.id,
      newSortId: question.sortId - 1,
    } as SortChangedEvent;
    this.field.props.onQuestionOrderChanged(evt);
  }

  moveOrderDown() {
    const question = this.field.props["question"] as SurveyQuestion;
    const evt = {
      id: question.id,
      newSortId: question.sortId + 1,
    } as SortChangedEvent;
    this.field.props.onQuestionOrderChanged(evt);
  }

  updateQuestionSortId(e){
    const question = this.field.props["question"] as SurveyQuestion;
    const evt = {
      id: question.id,
      newSortId: e.target.value,
      exact: true
    } as SortChangedEvent;
    this.field.props.onQuestionOrderChanged(evt);
  }
}
